import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/IPXInterfaceResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/ipxinterface/v1`;
	}
	create(e, t = !1) {
		return this.api.post(`${n.baseUrl}/interfaces?createPipelines=${t}`, e);
	}
	list(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/interfaces`, e));
	}
	duplicate(e, t) {
		return this.api.post(`${n.baseUrl}/interfaces/${t}`, e);
	}
	listIpxInterfacesByProjectId(e, t = {}) {
		return this.api.get(this.buildPath(`${n.baseUrl}/projects/interfaces`, {
			...t,
			projectId: e
		}));
	}
};
export { n as IPXInterfaceExperimentalResource };

//# sourceMappingURL=IPXInterfaceResource.js.map